var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmartMeter = function SvgSmartMeter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118 121",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d8426",
    fillRule: "evenodd",
    d: "M6.3 72.1v29.64h11.77v11.76l23.52-11.76h35.05l23.53 11.76v-11.76h11.52V72.1H6.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.83 57.37h58.58V33.85H29.83zm70.1-38.11a11.76 11.76 0 00-23.52 0h-35a11.77 11.77 0 00-23.53 0H6.3v52.93h105.4V19.26z",
    fill: "#0d8426",
    fillRule: "evenodd",
    opacity: 0.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmartMeter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "smart-meter.7a6825483dda7dfac9e831c1d1a65140.svg";